import { SLOT_KINDS, buildStaffCompletePayload } from "views/public/referralOnboardingApi";
import { formFromStaffValues } from "views/public/referralOnboarding/wizardConfig";
import {
  completeStaffOnboarding,
  fetchStaffOnboarding,
  uploadStaffOnboardingDocument,
} from "../../api/endpoints/enrolment";

const SLOT_BY_KIND = Object.fromEntries(
  Object.entries(SLOT_KINDS).map(([slot, kind]) => [kind, slot])
);

export const fromStaffOnboarding = (data) => ({
  organisationName: data.organisationName,
  termsVersion: data.termsVersion,
  termsHtml: data.termsHtml,
  form: formFromStaffValues(data.values),
  lockedFields: data.lockedFields || [],
  documentsOnFile: (data.documentKindsOnFile || [])
    .map((kind) => SLOT_BY_KIND[kind])
    .filter(Boolean),
});

/** The wizard for someone already signed in: no password, and their known details are locked. */
const staffOnboardingAdapter = {
  requirePassword: false,
  lockedHint: "From your account",
  load: () => fetchStaffOnboarding().then(fromStaffOnboarding),
  upload: uploadStaffOnboardingDocument,
  complete: (form, termsVersion) =>
    completeStaffOnboarding(buildStaffCompletePayload(form, termsVersion)),
};

export default staffOnboardingAdapter;
